module.exports = __webpack_public_path__ + "static/media/ву.de141ecf.mp3";